import React from "react";
import Encabezado from "../Encabezado";
import ContactNiveles from "../ContactNiveles";
import EncabezadoSimple from "../EncabezadoSimple";
import useTituloPagina from "../useTituloPagina";


export default function Contacto() {
  useTituloPagina(
    "Contacto",
    "Comunicate con el Colegio William C. Morris: José de Calasanz 144, Córdoba. Tel 0351-4232972."
  );

  return (
    <>
      {/* <Encabezado
        fondo={require("../../img/fondoMovimiento.jpg")}
        nivel={"Contacto"}
        frase={"Colegio Evangelico William C. Morris"}
        strength={150}
      /> */}
      <EncabezadoSimple clases="green"/>
      <ContactNiveles
      color="c2"
      nivel="contacto"
      emailSend="info.williamcmorris@gmail.com" 
      />
    </>
  );
}
